var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z",
    fill: "url(#paint0_linear_448_30793)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15H8V17H16V15Z",
    fill: "url(#paint1_linear_448_30793)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H8V13H16V11Z",
    fill: "url(#paint2_linear_448_30793)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H8V9H16V7Z",
    fill: "url(#paint3_linear_448_30793)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_30793",
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_30793",
    x1: 8,
    y1: 16,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_30793",
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_448_30793",
    x1: 8,
    y1: 8,
    x2: 16,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.fc040035d9f3ad5b9fb5babc97950aaf.svg";
export { ForwardRef as ReactComponent };